import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type == _ctx.counterpartyType.Consumer)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 0,
          size: "small",
          type: "success",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Заказчик")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.type == _ctx.counterpartyType.Contractor)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 1,
          size: "small",
          type: "warning",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Подрядчик")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.type == _ctx.counterpartyType.Supplier)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 2,
          size: "small",
          type: "primary",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Поставщик")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}